import React, { useState } from 'react';
import './Tooltip.css';

const Tooltip = ({ children, content, disabled = false }) => {
  const [isVisible, setIsVisible] = useState(false);

  if (!disabled || !content) {
    return children;
  }

  return (
    <div
      className="tooltip-wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div className="tooltip-content">
          {content}
          <div className="tooltip-arrow"></div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
